import { Navigate } from 'react-router-dom';
import { useUser } from './AuthProvider';

export function AdminGuard({ children }: { children: React.ReactNode }) {
  const { user, profile, loading, isAdmin } = useUser();
  if (loading) return null;
  if (!user) return <Navigate to="/signin" replace />;
  // Wait until the profile snapshot has loaded — otherwise we'd briefly
  // bounce admins away from admin pages on initial render.
  if (!profile) {
    return (
      <div className="flex h-64 items-center justify-center text-muted-foreground">
        Lade Profil …
      </div>
    );
  }
  if (!isAdmin) return <Navigate to="/" replace />;
  return <>{children}</>;
}
